/**
 * Страница пользователя: список проектов (user/projects).
 *
 * Маркер инициализации — наличие #deleteProjectModal.
 * Конфиг — window.userProjectsConfig (i18n).
 *
 * Функционал — модалка подтверждения удаления проекта + AJAX-удаление.
 */

function init() {
    if (!document.getElementById('deleteProjectModal')) return;

    const config = window.userProjectsConfig;
    if (!config) {
        console.error('[user-projects] window.userProjectsConfig not found');
        return;
    }

    const $ = window.jQuery || window.$;
    if (!$) {
        console.error('[user-projects] jQuery not loaded');
        return;
    }
    const showToast = window.showToast;

    function openDeleteModal(projectId, projectName) {
        $('#confirmDeleteBtn').prop('disabled', false).text(config.i18n.delete);
        $('#delete_project_id').val(projectId);
        $('#delete_project_name').text(projectName);
        $('#deleteProjectModal').fadeIn(200);
    }

    function closeDeleteModal() {
        $('#deleteProjectModal').fadeOut(200);
        $('#confirmDeleteBtn').prop('disabled', false).text(config.i18n.delete);
    }

    // Глобальный доступ для onclick="closeDeleteModal()" в шаблоне
    window.openDeleteModal = openDeleteModal;
    window.closeDeleteModal = closeDeleteModal;

    $(() => {
        $('.delete-project').on('click', function (e) {
            e.preventDefault();
            const $cell = $(this).closest('.projects_cell');
            $('#deleteProjectModal').data('cell', $cell);
            openDeleteModal($(this).data('id'), $(this).data('name'));
        });

        $('#confirmDeleteBtn').on('click', function () {
            const projectId = $('#delete_project_id').val();
            const $cell = $('#deleteProjectModal').data('cell');
            const $button = $(this);
            const originalText = $button.text();

            $button.prop('disabled', true).text(config.i18n.loading + '...');

            $.ajax({
                url: '/removeproject/' + projectId,
                type: 'DELETE',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                    'X-CSRF-TOKEN': config.csrfToken || $('meta[name="csrf-token"]').attr('content'),
                    Accept: 'application/json',
                },
                success() {
                    $button.prop('disabled', false).text(originalText);
                    closeDeleteModal();
                    if ($cell) $cell.fadeOut(400, function () { $(this).remove(); });
                },
                error(xhr) {
                    let message = config.i18n.errorDeleting;
                    if (xhr.responseJSON && xhr.responseJSON.message) {
                        message = xhr.responseJSON.message;
                    }
                    if (typeof showToast === 'function') {
                        showToast('error', message);
                    } else {
                        alert(message);
                    }
                    $button.prop('disabled', false).text(originalText);
                },
            });
        });

        $('#deleteProjectModal').on('click', function (e) {
            if (e.target === this) closeDeleteModal();
        });
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}
